module.exports = __webpack_public_path__ + "img/dd1a5.2b65a719.svg";